import React, { Component } from "react";
import { Row, Button, Col, Card, List, Icon } from "antd";
import { api, app, config } from "../../app";
import underscore from "underscore";
import MMOrderModal from "../../components/MMOrderModal";
import common from "../mall/common";

const order_state = common.order_state;

class MMOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders_id: "",
      data_loading: true,
      review_visible: false,
      order_info: {},
      reviewInfo:'',
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const orders_id = this.props.match.params.id;
    this.setState({ orders_id }, () => {
      this.DataList(orders_id);
    });
  }
  /**
   * 关闭
   * @constructor
   */
  CloseReviewModal = () => {
    this.setState({ review_visible: false, reviewInfo:'' });
  };
  // 编辑
  OpenReviewModal = (reviewInfo) => {
    this.setState({ review_visible: true,reviewInfo });
  };
  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 数据
   * @param orders_id
   * @constructor
   */
  DataList = (orders_id) => {
    const _this = this,
      params = {
        orders_id,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
    app.post(api.OrdersManageDetails, params).then(({ flag, data, msg }) => {
      if (_this._isMounted) {
        if (flag === 1) {
          _this.setState({ data_loading: false, order_info: data });
        } else {
          app.alert(msg, "warn");
        }
      }
    });
  };

  /**
   * 编辑买家留言
   * @param param
   * @returns {Promise<void>}
   */
  handleCheckReview = async (detail) => {
    let params = {
      buy_message: detail,
      orders_id: this.props.match.params.id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    app.post(api.ordersBuyMessageEdit, params).then(({ flag, data, msg }) => {
      if (flag === 1) {
        app.alert(msg, "success");
        this.setState({review_visible:false});
        const orders_id = this.props.match.params.id;
        this.setState({ orders_id }, () => {
          this.DataList(orders_id);
        });
      } else {
        app.alert(msg, "warn");
      }
    });
  };

  /**
   * 返回上一页
   **/
  handleBack = () => {
    this.props.history.go(-1);
  };

  render() {
    const { order_info, data_loading, review_visible,reviewInfo } = this.state;
    let state = "";
    if (order_info.is_cancel === "1") {
      state = "已取消";
    } else if (
      order_info.gstatus === "0" &&
      order_info.trade_status === "TRADE_SUCCESS"
    ) {
      state = "已付款";
    } else {
      let res = underscore.find(
        order_state,
        (os) => os.id === order_info.gstatus
      );
      if (res) {
        state = res.name;
      }
    }
    let pay_method_text = "";
    switch (order_info.pay_method + "") {
      case "1":
        pay_method_text = "（支付宝）";
        break;
      case "2":
        pay_method_text = "（微信）";
        break;
      case "3":
        pay_method_text = "（支付宝）";
        break;
      case "4":
        pay_method_text = "（微信）";
        break;
    }
    return (
      <div className="mall-manage-order-detail">
        <div className="detail1">
          <div style={{ marginBottom: 15 }}>
            <Button onClick={() => this.handleBack()}>返回</Button>
          </div>
          <Row type="flex">
            <h1 className="title flex-eq">
              订单号：{order_info.out_trade_no}
              {pay_method_text}
            </h1>
            {/*<div className="action-btn flex-eq">*/}
            {/*<Button.Group>*/}
            {/*<Button type="primary">无法生产</Button>*/}
            {/*<Button type="primary">重复订单</Button>*/}
            {/*<Button type="primary">不生产</Button>*/}
            {/*<Button type="primary">重新处理</Button>*/}
            {/*<Button type="primary">发货</Button>*/}
            {/*</Button.Group>*/}
            {/*</div>*/}
          </Row>
          <Row type="flex">
            <div className="flex-eq order-info">
              <Row gutter={40}>
                <Col span={24}>
                  {/* {JSON.stringify(order_info)} */}
                  <div className="term-l">收货信息</div>
                  <div className="term-r">
                    {order_info.receiver_name
                      ? order_info.receiver_name + ","
                      : ""}
                    {order_info.receiver_phone
                      ? order_info.receiver_phone + ","
                      : ""}
                    {order_info.receiver_address
                      ? order_info.receiver_address
                      : ""}
                  </div>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">创建人</div>
                  <div className="term-r">{order_info.vname}</div>
                </Col>
                <Col span={12}>
                  <div className="term-l">管理员审核</div>
                  <div className="term-r">
                    {order_info.admin_name || "暂无"}
                  </div>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">创建时间</div>
                  <div className="term-r">{order_info.datetime}</div>
                </Col>
                <Col span={12}>
                  <div className="term-l">管理员审核时间</div>
                  {/* <div className="term-r">{order_info.team_header_time || "暂无"}</div> */}
                  <div className="term-r">
                    {order_info.admin_time || "暂无"}
                  </div>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">支付时间</div>
                  <div className="term-r">
                    {order_info.send_pay_date || "暂无"}
                  </div>
                </Col>
                <Col span={12}>
                  <div className="term-l">管理员审核状态</div>
                  <div className="term-r">
                    {/* {order_info.team_header_is_confirm === "true" ? "已通过" : (order_info.detail ? "不通过" : "未审核")} */}
                    {order_info.admin_is_onfirm === "true"
                      ? "已通过"
                      : order_info.detail
                      ? "不通过"
                      : "未审核"}
                  </div>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">发货时间</div>
                  <div className="term-r">
                    {order_info.delivery_time || "暂无"}
                  </div>
                </Col>
                <Col span={12}>
                  <div className="term-l">管理员姓名</div>
                  <div
                    // className="term-r">{order_info.team_header_name || "暂无"}</div>
                    className="term-r"
                  >
                    {order_info.admin_name || "暂无"}
                  </div>
                </Col>
                {/* <Col span={12}>
                                    <div className="term-l">备注</div>
                                    <div className="term-r">{order_info.remark || '无'}</div>
                                </Col> */}
                {/* <Col span={12}>
                                    <div className="term-l">省级/超管</div>
                                    <div
                                        className="term-r">{order_info.admin_name || "暂无"}</div>
                                </Col> */}
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">快递公司</div>
                  <div className="term-r">
                    {order_info.courier_company || "暂无"}
                  </div>
                </Col>
                {/* <Col span={12}>
                                    <div className="term-l">省级/超管审核时间</div>
                                    <div className="term-r">{order_info.admin_time || "暂无"}</div>
                                </Col> */}

                {/* <Col span={12}>
                                    <div className="term-l">省级/超级管理员姓名</div>
                                    <div
                                        className="term-r">{order_info.admin_name || "暂无"}</div>
                                </Col> */}
              </Row>
              <Row gutter={40}>
                <Col span={12}>
                  <div className="term-l">快递单号</div>
                  <div className="term-r">
                    {order_info.courier_number || "暂无"}
                  </div>
                </Col>
                {/* <Col span={12}>
                                    <div className="term-l">省级/超管审核状态</div>
                                    <div
                                        className="term-r">{order_info.admin_is_onfirm === "true" ? "已通过" : (order_info.detail ? "不通过" : "未审核")}</div>
                                </Col> */}
              </Row>
              <Row gutter={40}>
                <Col span={24}>
                  <div className="term-l">异常原因</div>
                  <div className="term-r">{order_info.detail || "无"}</div>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={24}>
                  <div className="term-l">买家留言</div>
                  <div className="term-r">{order_info.buy_message || "无"}</div>
                  <Button
                    size="small"
                    type="primary"
                    onClick={() => this.OpenReviewModal(order_info.buy_message)}
                  >
                    编辑留言
                  </Button>
                </Col>
              </Row>
              <Row gutter={40}>
                <Col span={24}>
                  <div className="term-l">备注</div>
                  <div className="term-r">{order_info.remark || "无"}</div>
                </Col>
              </Row>
            </div>
            <div className="flex-eq sta-pri">
              <Row>
                <Col span={12}>
                  <div className="term-t">订单状态</div>
                  <div className="term-b">{state}</div>
                </Col>
                <Col span={12}>
                  <div className="term-t">订单总金额</div>
                  <div className="term-b">￥{order_info.total_amount}</div>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
        <div className="detail2">
          <Card
            title={"商品信息"}
            extra={`共${(order_info.mall_info || []).length}件`}
            bordered={false}
          >
            <List
              bordered={true}
              itemLayout="horizontal"
              dataSource={order_info.mall_info || []}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <div className="good-img">
                        <img src={config.imgUrl + item.localpath} />
                      </div>
                    }
                    title={item.ppename}
                    description={
                      <div
                        style={{
                          padding: "2px 4px",
                          background:
                            item.custom_name == "" || item.custom_name == null
                              ? ""
                              : "#f2f2f2",
                          display: "inline-block",
                          borderRadius: "4px",
                        }}
                      >
                        {item.details_huopin_content +
                          (item.custom_name ? `（${item.custom_name}）` : "")}
                      </div>
                    }
                  />
                  <div className="good-count" style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "14px" }}>
                      ￥ {item.details_money}
                    </div>
                    <div>
                      <Icon type="close" /> {item.details_nums}
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      小计：￥ {item.amount}
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </Card>
          <MMOrderModal
            visible={review_visible}
            close={this.CloseReviewModal}
            label={"买家留言"}
            reviewInfo={reviewInfo}
            submit={(detail) => this.handleCheckReview(detail)}
          />
        </div>
      </div>
    );
  }
}

export default MMOrderDetail;



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMOrderDetail.jsx